// export const BUSINESS_TOTAL_SCORE = 5;
export const TIMESLOT_DURATION = 15;
export const NAVBAR_HEIGHT = '5rem';

export enum LOGIN_STEPS {
    STEP_1 = 1,
    STEP_2 = 2,
    STEP_3 = 3,
    STEP_4 = 4
};

export enum MODAL_CART_STAGES {
    SELECT_SERVICES = 1,
    SELECT_EMPLOYEE = 2,
    SELECT_DATE = 3,
    SELECT_TIME = 4,
    BOOKING_SUMMARY = 5,
    PAYMENT_METHOD = 6,
    BOOKING_SUCCESS = 7
};

export enum NAV_SIZES {
    SMALL = 'SMALL',
    BIG = 'BIG'
};

export enum BOOKING_STATUS {
    PENDING = 'PENDING',
    CONFIRMED = 'CONFIRMED',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    NO_SHOW = 'NO SHOW',
};

export enum ALERT_RESPONSES {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
};

export enum EMPLOYEE_STATUS {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
};

// LATAM Country Codes for phone input
export const COUNTRY_CODES = [
    { code: 'UY', dial: '+598', name: 'Uruguay', flag: '🇺🇾' },
    { code: 'AR', dial: '+54', name: 'Argentina', flag: '🇦🇷' },
    { code: 'BR', dial: '+55', name: 'Brasil', flag: '🇧🇷' },
    { code: 'CL', dial: '+56', name: 'Chile', flag: '🇨🇱' },
    { code: 'PY', dial: '+595', name: 'Paraguay', flag: '🇵🇾' },
    { code: 'PE', dial: '+51', name: 'Perú', flag: '🇵🇪' },
    { code: 'CO', dial: '+57', name: 'Colombia', flag: '🇨🇴' },
    { code: 'EC', dial: '+593', name: 'Ecuador', flag: '🇪🇨' },
    { code: 'BO', dial: '+591', name: 'Bolivia', flag: '🇧🇴' },
    { code: 'VE', dial: '+58', name: 'Venezuela', flag: '🇻🇪' },
    { code: 'MX', dial: '+52', name: 'México', flag: '🇲🇽' },
];

export const DEFAULT_COUNTRY_CODE = '+598'; // Uruguay

export enum PRICING_TYPE {
    FIXED = 'FIXED',
    VARIABLE = 'VARIABLE',
}

export const TIME_OF_DAY_OPTIONS = [
    { value: 'morning', label: 'Mañana' },
    { value: 'afternoon', label: 'Tarde' },
    { value: 'evening', label: 'Noche' },
];

export const TATTOO_SIZE_OPTIONS = [
    { value: 'tiny', label: 'Muy pequeño (< 5cm)' },
    { value: 'small', label: 'Pequeño (5-10cm)' },
    { value: 'medium', label: 'Mediano (10-20cm)' },
    { value: 'large', label: 'Grande (20-30cm)' },
    { value: 'extraLarge', label: 'Muy grande (30cm+)' },
    { value: 'fullDay', label: 'Sesión de día completo' },
];

export const LANGUAGE_OPTIONS = [
    { value: 'spanish', label: 'Español' },
    { value: 'english', label: 'English' },
    { value: 'portuguese', label: 'Português' },
];

export const APP_STORE_URL = 'https://apps.apple.com/uy/app/mora-biz/id6476923418';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.marcosberrutti.mora';